import { defineStore } from 'pinia'
import type { INavigationLink } from '~/shared/interfaces/ui/navigation'
import type { IBalance, IProfile } from '~/shared/interfaces/account'
import type { TSearchHistoryData, IHistoryItem } from '~/shared/interfaces/account/searchHistory'
import type {TUserRole} from "~/shared/interfaces/user";

interface AccountState {
  accountNavigationList: INavigationLink[]
  balance: IBalance[]
  userProfile: IProfile | null
  userHistoryQueries: TSearchHistoryData | null
  userRole: TUserRole
}

const useAccountStore = defineStore('account', {
  state: (): AccountState => ({
    accountNavigationList: [
      {
        name: 'Мой профиль',
        path: '/account',
        value: 'account',
      },
      {
        name: 'Личные данные',
        path: '/account/personal',
        value: 'personal',
      },
      {
        name: 'Менеджеры',
        path: '/account/managers',
        value: 'managers',
      },
      {
        name: 'Мои заказы',
        path: '/account/orders',
        counter: 0,
        value: 'orders',
      },
      {
        name: 'Мои адреса',
        path: '/account/addresses',
        value: 'addresses',
      },
      {
        name: 'Финансы',
        path: '/account/finance',
        value: 'finance',
        show: Number(useRuntimeConfig().public.showBalance)
      },
      {
        name: 'Юридические лица',
        path: '/account/companies',
        value: 'companies',
      },
      {
        name: 'Сортировка складов',
        path: '/account/sorting-warehouses',
        value: 'sorting-warehouse',
      },
      {
        name: 'История поиска',
        path: '/account/search-history',
        value: 'search-history',
      },
    ],
    balance: [],
    userProfile: null,
    userHistoryQueries: null,
    userRole: 'guest',
  }),
  getters: {
    getUserHistoryQueriesLength(): number {
      if (this.userHistoryQueries && Object.keys(this.userHistoryQueries).length) {
        return Object.keys(this.userHistoryQueries).length
      }
      return 0
    }
  },
  actions: {
    setUserRole(role: TUserRole) {
      this.userRole = role
    },
    setBalance(balanceData: IBalance[]) {
      this.balance = balanceData;
    },
    setUserProfile(profile: IProfile) {
      this.userProfile = profile
    },
    setUserHistory(history: TSearchHistoryData) {
      this.userHistoryQueries = history
    },
    setUserHistoryItem(key: string, item: IHistoryItem[]) {
      if (this.userHistoryQueries) {
        this.userHistoryQueries[key] = item
      }
    },
    deleteUserHistoryItemUnit(key: string, createdAt: string) {
      if (this.userHistoryQueries) {
        this.userHistoryQueries[key] = this.userHistoryQueries[key].filter(el => el.created_at !== createdAt)

        if (!Object.keys(this.userHistoryQueries[key]).length) {
          delete this.userHistoryQueries[key]
        }
      }
    },
    clearSearchHistory() {
      this.userHistoryQueries = null
    }
  }
})

export default useAccountStore
